module.exports = __webpack_public_path__ + "assets/img/hospital-02-white.b92dace3.svg";